<template>
  <v-card class="theme-bg">
    <v-row>
    <div class="widget">
      <div class="left-panel panel">
        <div class="date">{{locationDetails.date}}</div>
        <div class="city">{{locationDetails.city}}</div>
        <div>{{locationDetails.region}}, {{locationDetails.country}}</div>
      </div>
      <div class="temp">27&deg;</div>
      <div class="right-panel panel">
        <img src="https://s5.postimg.cc/yzcm7htyb/image.png" alt width="30" />
      </div>
    </div>
    </v-row>
  </v-card>
</template>


<script>
export default {
  name: "Weather",
  data: () => ({
    weather: `Today's weather`,
    locationDetails: {},
  }),
  methods: {
    getWeather: async function () {
      const response = await fetch("http://ipinfo.io?token=6559e498fd84f3");
      this.locationDetails = await response.json();
      this.locationDetails.date = new Date().toDateString();
      console.log(this.locationDetails);
    },
  },
  mounted() {
    this.getWeather();
  },
};
</script>

<style scoped>
.theme-bg {
  background: #10163a;
  height: 300px;
  max-height: 300px;
}
.text-color {
  color: #fff !important;
}
.container {
  padding: 15px;
}
* {
  margin: 0;
  padding: 0;
  outline: none;
}

.panel img {
  width: 100px;
}

div.widget {
  padding: 25px;
  padding-right: 30px;
}

div.date {
  font-size: 14px;
  font-weight: bold;
  color: fff;
}

div.temp {
  font-size: 81px;
  color: rgba(0, 0, 0, 0.9);
  font-weight: 100;
}

div.panel {
  display: inline-block;
}

div.right-panel {
  position: absolute;
  right: 50px;
  top: 0;
  margin-top: 35px;
  padding-left: 10px;
}
</style>
